import { ApiConfigService } from '@nextgen-web-framework/core';
import data from '@com.amway.commerce/masterdata-country-v1-production/data.json';

const usePhoneNumberData = () => {
  const tuple = ApiConfigService.getTuples();
  const currentCountry = tuple['X-Amway-Country'] || '';

  data.sort((a, b) => {
    if (a.countryName.toLowerCase() < b.countryName.toLowerCase()) {
      return -1;
    }
    if (a.countryName.toLowerCase() > b.countryName.toLowerCase()) {
      return 1;
    }
    return 0;
  });

  const currentIndex = data.findIndex((item) => item.pk.toLowerCase() === currentCountry.toLowerCase());

  if (currentIndex !== -1) {
    const currentCountryObj = data[currentIndex];
    data.splice(currentIndex, 1);
    data.unshift(currentCountryObj);
  }

  const [defaultCountry] = data;

  const result = data.map((item) => ({
    id: item.pk,
    name: `(+${item.phoneCode}) ${item.countryName}`,
    callingCode: `+${item.phoneCode}`,
    countryName: item.countryName,
  }));

  return {
    data: result,
    defaultCountryCodeObject: defaultCountry,
    defaultCountryCode: defaultCountry ? `+${defaultCountry.phoneCode}` : '',
  };
};

export default usePhoneNumberData;
